import {
  LockedFeaturesUpsellContent,
  LockedFeaturesUpsellContentType
} from '../../../constants/lockedFeatures'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { RootState } from '@dtx-company/inter-app/src/redux/types'
import { clearLockedFeatureModal } from '@dtx-company/inter-app/src/redux/slices/lockedFeatureModalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo, useState } from 'react'
import { useIsBillingAdmin } from '@dtx-company/inter-app/src/hooks/useIsBillingAdmin/useIsBillingAdmin'
import { useLockedFeatureModalContext } from '../context/useLockedFeatureModalContext'
import { usePageLimit } from '@app/page/src/components/flowpage/ClaimSlug/hooks/usePageLimit'
import { usePaymentMethodError } from '../../PlanPurchaseExperience/usePaymentMethodError'

export const useLockedFeatureModal = (): {
  open: boolean
  onClose: (reason?: 'success' | 'dismiss') => void
  lockedFeatureName?: string
  lockedFeaturePlanType?: PlanType
  lockContent?: LockedFeaturesUpsellContentType
} => {
  const dispatch = useDispatch()
  const { lockedFeatureName, planType: lockedFeaturePlanType } = useSelector(
    (state: RootState) => state.revenueReducer.lockedFeatureModal
  )
  const { onClose: onCloseModal } = useLockedFeatureModalContext()
  const [open, setOpen] = useState(false)
  const isBillingAdmin = useIsBillingAdmin()
  const { getErrorMessage } = usePaymentMethodError()
  const { pageLimit } = usePageLimit()

  useEffect(() => {
    if (!lockedFeatureName) return
    setOpen(true)
  }, [isBillingAdmin, dispatch, getErrorMessage, lockedFeatureName])

  const onClose = (reason?: 'success' | 'dismiss'): void => {
    if (reason) {
      onCloseModal?.(reason)
    }
    dispatch(clearLockedFeatureModal())
    setOpen(false)
  }

  const lockContent = useMemo(() => {
    if (lockedFeatureName) {
      if (lockedFeatureName === 'page_limit' && pageLimit === 0) {
        return LockedFeaturesUpsellContent['page_limit_free_and_trial']
      }
      return LockedFeaturesUpsellContent[lockedFeatureName]
    } else return undefined
  }, [lockedFeatureName, pageLimit])

  return { open, onClose, lockedFeatureName, lockedFeaturePlanType, lockContent }
}
